import { api } from '../config/api';

export interface Tag {
  id: number;
  name: string;
  color: string;
  description?: string;
  created_at: string;
  updated_at?: string;
  document_count?: number;
  property_count?: number;
}

export interface CreateTagData {
  name: string;
  color?: string;
  description?: string;
}

export interface UpdateTagData {
  name?: string;
  color?: string;
  description?: string;
}

class TagsService {
  async getTags(): Promise<Tag[]> {
    const response = await api.get('/tags/');
    return response.data;
  }

  async getTag(id: number): Promise<Tag> {
    const response = await api.get(`/tags/${id}`);
    return response.data;
  }

  async createTag(data: CreateTagData): Promise<Tag> {
    const response = await api.post('/tags/', data);
    return response.data;
  }

  async updateTag(id: number, data: UpdateTagData): Promise<Tag> {
    const response = await api.put(`/tags/${id}`, data);
    return response.data;
  }

  async deleteTag(id: number): Promise<void> {
    await api.delete(`/tags/${id}`);
  }

  // Document tag operations
  async addTagToDocument(tagId: number, documentId: number | string): Promise<void> {
    await api.post(`/tags/${tagId}/documents/${documentId}`);
  }

  async removeTagFromDocument(tagId: number, documentId: number | string): Promise<void> {
    await api.delete(`/tags/${tagId}/documents/${documentId}`);
  }

  // Property tag operations
  async addTagToProperty(tagId: number, propertyId: number): Promise<void> {
    await api.post(`/tags/${tagId}/properties/${propertyId}`);
  }

  async removeTagFromProperty(tagId: number, propertyId: number): Promise<void> {
    await api.delete(`/tags/${tagId}/properties/${propertyId}`);
  }
}

export const tagsService = new TagsService();